import { Injectable, Component } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, Subject, BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';
import { AppEnum } from '../providers/app.enum';
import * as CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root'
})

export class AppServiceService {

  // public serviceURL = 'http://localhost/AnchorApps/Anchor-Software-Solution/Api/';
  // public apiUrl = 'http://localhost/AnchorApps/patient-signin-api/RestController.php';
  // public apiCsaUrl ='http://localhost/AnchorApps/Anchor-Software-Solution/Api/CsDashboard/';
  

  public serviceURL = 'http://104.248.63.174/Anchor-Software-Solution/Api/';
  public apiUrl = 'http://104.248.63.174/patient-signin-api/RestController.php';
  public apiCsaUrl ='http://104.248.63.174/Anchor-Software-Solution/Api/CsDashboard/';
  
  // public serviceURL = 'http://137.184.27.248/Anchor-Software-Solution/Api/';
  // public apiUrl = 'http://137.184.27.248/patient-signin-api/RestController.php';
  // public apiCsaUrl ='http://137.184.27.248/Anchor-Software-Solution/Api/CsDashboard/';

  // public serviceURL = 'https://anchorsoftwaresolutions.com/Anchor-Software-Solution/Api/';
  // public apiUrl = 'https://anchorsoftwaresolutions.com/patient-signin-api/RestController.php';
  // public apiCsaUrl ='https://anchorsoftwaresolutions.com/Anchor-Software-Solution/Api/CsDashboard/';

  
  // public serviceURL = 'https://myapps.ansosol.com/admin/api/';
  // public apiUrl = 'https://myapps.ansosol.com/patient-signin-api/RestController.php';
  //public serviceURL = 'http://96.250.208.59/Anchor-Apps/admin/api/';
  //public apiUrl = 'http://96.250.208.59/Anchor-Apps/patient-signin-api/RestController.php';
  public appSetting;
  
  constructor(public http: HttpClient, public appEnum: AppEnum) { }

  getURL() {
    const jsonData = this.decryptData(localStorage.getItem('LogInDetails'));
    this.appSetting = JSON.parse(jsonData);
  }

  getAdminURL() {
    const jsonData = this.decryptData(localStorage.getItem('AdminDetails'));
    this.appSetting = JSON.parse(jsonData);
  }

  getData(url): Observable<any> {
    return this.http.get(url)
      .pipe(map(results => {
        return results;
      }
      ));
  }

  postData(url, data): Observable<any> {
    return this.http.post(url, data)
      .pipe(map(results => {
        return results;
      }
      ));
  }

  encryptData(data) {
    // const encryptedData = CryptoJS.encrypt(JSON.stringify(data), 'a');
   const encryptedData = CryptoJS.AES.encrypt(JSON.stringify(data), 'a');
    return encryptedData;
  }

  decryptData(data) {
    const bytes = CryptoJS.AES.decrypt(data.toString(), 'a');
    const decryptedData = bytes.toString(CryptoJS.enc.Utf8);
    return decryptedData;
  }
}
